import React from 'react';
import { Key, CheckCircle } from 'lucide-react';

// This page is not yet wired to a backend. It deliberately renders no keys,
// usage figures or rate limits: there is no API-key service to source them from.
const APIKeysManagement = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900">API Keys Management</h1>
        <p className="text-gray-600 mt-1">Manage platform API keys and access tokens</p>
      </div>

      {/* Empty state */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center">
        <div className="w-14 h-14 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Key className="w-7 h-7 text-gray-400" />
        </div>
        <h2 className="text-lg font-semibold text-gray-900">API key management is not available yet</h2>
        <p className="text-sm text-gray-600 mt-2 max-w-md mx-auto">
          This feature is not connected to a backend service yet, so no keys can be
          listed, created or revoked from here.
        </p>
      </div>

      {/* Guidelines */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4">API Usage Guidelines</h3>
        <div className="space-y-3 text-sm text-gray-600">
          {[
            'Keep your API keys secure and never share them publicly',
            'Rotate keys regularly for enhanced security',
            'Use different keys for production and development environments',
            'Monitor API usage to detect unusual activity',
          ].map((text) => (
            <div key={text} className="flex items-start gap-2">
              <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
              <p>{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default APIKeysManagement;
